var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-registration',{attrs:{"invitation-token":_vm.$route.query.invitationToken}})}
var staticRenderFns = []

export { render, staticRenderFns }